import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <div className="flex-1 min-w-0 flex flex-col relative">
        {/* Ambient brand glow behind content */}
        <div className="pointer-events-none absolute inset-0 -z-10 bg-radial-brand opacity-60 dark:opacity-100" />
        <Topbar onMobileMenu={() => setMobileOpen(true)} />
        <main className="flex-1 min-w-0 overflow-x-auto">
          <div className="px-4 md:px-8 py-5 md:py-7 w-full">
            <div className="animate-fade-in-up">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
